import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 hero-bg">
        <img
          src="https://public.readdy.ai/ai/img_res/6ecab19d6ed7d502d405afbbde1f5ce2.jpg"
          alt="대한문신사중앙회 중구지부"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/55 lg:bg-transparent" />
        <div className="absolute inset-0 hidden lg:block bg-gradient-to-r from-black/70 via-black/40 to-black/10" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-5 md:px-6 pt-24 pb-16 flex flex-col lg:flex-row items-center gap-12">
        {/* Left Content */}
        <div className="flex-1 text-center lg:text-left">
          {/* 인증 뱃지 */}
          <div className="hero-badge inline-flex items-center gap-2 px-4 py-2 rounded-sm bg-white/15 border border-white/30 mb-6 backdrop-blur-sm">
            <i className="ri-shield-check-line text-[#C9A84C] text-sm" />
            <span className="text-white text-xs font-semibold tracking-widest leading-relaxed">
              보건복지부 정식 인가 기관<br />
              <span className="text-[#C9A84C]">(대표 단체)</span>
            </span>
          </div>

          {/* 메인 슬로건 */}
          <h1 className="hero-title text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-white leading-snug mb-5" style={{ lineHeight: '1.6' }}>
            대한민국 반영구 문신의 표준,<br />
            <span className="text-[#C9A84C]">대한문신사중앙회 중구지부</span>에서<br />
            시작하세요.
          </h1>

          <p className="hero-desc text-white/75 text-sm md:text-base mb-8 leading-relaxed max-w-lg mx-auto lg:mx-0">
            반영구 문신 · 두피 · 입술 · 아이라인 전문<br />
            본회 공식 자격증 발급 · 창업 컨설팅 · 위생교육 원스톱 지원
          </p>

          <div className="hero-cta flex flex-col sm:flex-row gap-3 mb-8 w-full sm:w-auto">
            <Link
              to="/academy#consult"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-[#C9A84C] text-white font-bold text-sm hover:bg-[#b8963e] transition-colors cursor-pointer w-full sm:w-auto"
            >
              <i className="ri-edit-line" />
              수강 상담 신청하기
            </Link>
            <Link
              to="/academy"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md border-2 border-white/50 text-white font-semibold text-sm hover:bg-white/10 transition-colors cursor-pointer w-full sm:w-auto"
            >
              교육과정 보기
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          {/* 신뢰 지표 */}
          <div className="hero-trust flex flex-wrap justify-center lg:justify-start gap-x-5 gap-y-3">
            {[
              { icon: 'ri-award-line', text: '본회 공식 인증' },
              { icon: 'ri-graduation-cap-line', text: '자격증 발급 기관' },
              { icon: 'ri-user-star-line', text: '1,200+ 수료생' },
              { icon: 'ri-government-line', text: '정부 정식 인가' },
            ].map((b) => (
              <div key={b.text} className="flex items-center gap-2">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#C9A84C]/25">
                  <i className={`${b.icon} text-[#C9A84C] text-xs`} />
                </div>
                <span className="text-white/70 text-xs">{b.text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Right: 대한문신사중앙회 인증 카드 */}
        <div className="hero-card hidden lg:block flex-shrink-0 w-80">
          <div className="relative rounded-2xl overflow-hidden border border-white/20 backdrop-blur-md bg-black/40">
            <div className="h-1 w-full bg-gradient-to-r from-[#C9A84C] via-[#e8cc7a] to-[#C9A84C]" />
            <div className="px-6 pt-6 pb-5 border-b border-white/15">
              <div className="flex items-center gap-3">
                <div className="relative">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#C9A84C]/20 border border-[#C9A84C]/40">
                    <i className="ri-shield-star-line text-[#C9A84C] text-xl" />
                  </div>
                  <span className="absolute -top-0.5 -right-0.5 w-3.5 h-3.5 bg-[#C9A84C] rounded-full border-2 border-white/20 flex items-center justify-center">
                    <i className="ri-check-line text-white" style={{ fontSize: '7px' }} />
                  </span>
                </div>
                <div>
                  <p className="text-white font-black text-sm tracking-wide">대한문신사중앙회 공식 인증 지부</p>
                  <p className="text-white/50 text-xs mt-0.5">(사)대한문신사중앙회 · 중구지부</p>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-px bg-white/10 border-b border-white/15">
              {[
                { icon: 'ri-group-line', value: '1,200+', label: '누적 수료생' },
                { icon: 'ri-medal-line', value: '98%', label: '자격증 취득률' },
                { icon: 'ri-time-line', value: '15년+', label: '교육 경력' },
                { icon: 'ri-calendar-line', value: '2010', label: '설립연도' },
              ].map((stat) => (
                <div key={stat.label} className="bg-white/5 px-5 py-4 flex flex-col items-center text-center">
                  <i className={`${stat.icon} text-[#C9A84C] text-base mb-1.5`} />
                  <p className="text-white font-black text-lg leading-none">{stat.value}</p>
                  <p className="text-white/45 text-xs mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
            <div className="px-6 py-5 space-y-3">
              {[
                { icon: 'ri-government-line', text: '보건복지부 정식 인가' },
                { icon: 'ri-award-line', text: '공식 자격증 발급 기관' },
                { icon: 'ri-heart-pulse-line', text: '위생교육 지정 기관' },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#C9A84C]/15 flex-shrink-0">
                    <i className={`${item.icon} text-[#C9A84C] text-xs`} />
                  </div>
                  <span className="text-white/75 text-xs">{item.text}</span>
                  <i className="ri-check-line text-[#C9A84C] text-xs ml-auto" />
                </div>
              ))}
            </div>
            <div className="px-6 pb-6">
              <Link
                to="/about"
                className="whitespace-nowrap w-full flex items-center justify-center gap-2 py-3 rounded-lg border border-[#C9A84C]/50 text-[#C9A84C] text-xs font-bold hover:bg-[#C9A84C]/10 transition-colors cursor-pointer"
              >
                <i className="ri-verified-badge-line" />
                인증 현황 자세히 보기
              </Link>
            </div>
            <div className="absolute -bottom-8 -right-8 w-32 h-32 rounded-full bg-[#C9A84C]/5 pointer-events-none" />
            <div className="absolute -top-6 -left-6 w-24 h-24 rounded-full bg-white/5 pointer-events-none" />
          </div>
        </div>
      </div>

      {/* 스크롤 인디케이터 */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 animate-bounce">
        <span className="text-white/40 text-xs tracking-widest">SCROLL</span>
        <i className="ri-arrow-down-line text-white/40" />
      </div>
    </section>
  );
}
